import type { RouteObject } from 'react-router';

import { ServerErrorPage } from './ServerError';

/**
 * The named server-error route. One `RouteObject`, so the file is `.route.tsx`
 * singular.
 *
 * It sits in the **unguarded** shell layout, and that is load-bearing rather
 * than incidental: the guard chain's own `GET /api/v1/me` is one of the calls
 * that can fail, and a surface that exists to say «the service did not answer»
 * cannot be gated behind an answer from the service.
 *
 * It fetches nothing. There is no state to read on a page whose whole content is
 * a statement about a request that already failed, and a read here would be one
 * more thing that can fail while failing.
 */
export const serverErrorRoute: RouteObject = {
  path: '/500',
  element: <ServerErrorPage />,
};
